export const MODEL_CONFIG = {
  groqTranscription: 'whisper-large-v3-turbo',
  geminiTranslation: 'gemini-3.1-flash-lite',
  geminiTts: 'gemini-3.1-flash-tts-preview',
} as const;

export const MEDIA_LIMITS = {
  desktopBytes: 1_500_000_000,
  mobileBytes: 400_000_000,
  chunkSeconds: 90,
  lowMemoryChunkSeconds: 45,
  overlapSeconds: 0.5,
  proxyChunkBytes: 3_600_000,
} as const;
export const SUPPORTED_EXTENSIONS = ['mp4', 'webm', 'mov', 'm4v'];
export const API_BASE = '/.netlify/functions';
